// extracted by mini-css-extract-plugin
export default {"blog":"styles_blog__2MKtj","blog__link":"styles_blog__link__oZRQu","item":"styles_item__mF3Bc","item__in":"styles_item__in__OqVk4"};